import Select from '../Select'
import useMarketBankAccounts from '../../hooks/useMarketBankAccounts'

interface Props {
    marketId: string
    label?: string
    selectedBankAccountId?: string | null
    onSelect: (bankAccountId: string) => void
}

export const formatBankAccountName = (name: string, bban: string) =>
    bban ? `${name} (${bban})` : name

const BankAccountSelect = ({ marketId, label = 'Bank account', selectedBankAccountId, onSelect }: Props) => {
    const accounts = useMarketBankAccounts(marketId)

    const getOptions = () => {
        return [{ name: 'Not selected', value: '', disabled: true }].concat(
            accounts
                .map(account => {
                    return {
                        name: formatBankAccountName(account.name, account.bban),
                        value: account.bankAccountId,
                        disabled: false
                    }
                })
        )
    }

    return (
        <Select
            id='bankAccount'
            key='bankAccount'
            label={label}
            options={getOptions()}
            selectedValue={selectedBankAccountId ?? ''}
            onSelect={onSelect}
        />
    )
}

export default BankAccountSelect
